<template>
  <div>
    <div class="customerGroup" v-if="isLimit">
      <van-form ref="form">
        <van-cell required title="群发名称">
          <template #default>
            <van-field
              style="padding: 3px; margin-bottom: -3px"
              v-model="groupName"
              name="groupName"
              type="text"
              maxlength="30"
              show-word-limit
              placeholder="请输入..."
              :rules="[{ required: true, message: '请输入群发名称' }]"
            />
          </template>
        </van-cell>
        <van-cell required title="所属员工">
          <template #default>
            <van-field
              class="users_field"
              v-model="user_str"
              placeholder="请输入..."
              name="user"
              ref="users_field"
              :style="{ display: user_str ? 'block' : 'none' }"
              :rules="[{ required: true, message: '请选择所属员工' }]"
            >
              <template #input>
                <div class="text_wrap usersWrap">
                  <span class="userItem">{{ user_str }}</span>
                </div>
                <p class="show" @click="expandClickUser" v-show="isUserMore">
                  <span>{{ "展开全部员工(" + users.length + ")" }}</span>
                  <van-icon name="play" />
                </p>
              </template>
            </van-field>
          </template>
          <template #icon>
            <div class="right_arrow" @click="routerUser">
              <span :style="{ opacity: users.length ? 0 : 1 }">请选择</span>
              <van-icon name="arrow" />
            </div>
          </template>
        </van-cell>
        <van-cell title="企业标签">
          <template #default>
            <div class="text_wrap tagWraps" v-show="tags.length > 0">
              <span class="tagItem" v-for="item in tags" :key="item.id">{{ item.name }}</span>
            </div>
            <p class="show" @click="expandClickTag" v-show="isTagMore">
              <span>{{ "展开全部标签(" + tags.length + ")" }}</span>
              <van-icon name="play" />
            </p>
          </template>
          <template #icon>
            <div class="right_arrow" @click="routerTag">
              <span :style="{ opacity: tags.length ? 0 : 1 }">请选择</span>
              <van-icon name="arrow" />
            </div>
          </template>
        </van-cell>

        <van-cell title="预计发送人数">
          <!--        <template #default>-->
          <!--          -->
          <!--        </template>-->
          <template #icon>
            <div class="right_arrow" style="right: 12px">
              <span>{{ sendCount }}</span>
            </div>
          </template>
        </van-cell>
        <van-cell title="消息内容" required>
          <template #default>
            <van-field
              v-model="messageWord"
              name="messageWord"
              type="textarea"
              rows="3"
              autosize
              maxlength="1000"
              show-word-limit
              placeholder="请输入..."
              :rules="[{ required: true, message: '请输入消息内容' }]"
            />
            <dl class="speare_line"></dl>
            <add-file @isFixedBottom="isFixedBottom" @listArr="listArr"></add-file>
          </template>
        </van-cell>
      </van-form>
      <!--    最下面-->
      <div class="bottom_word">
        <p>注：</p>
        <p>1. 企业微信客户每个自然月最多接受来自同一企业微信管理员的4条群发消息，4条消息可在同一天发送；</p>
        <p>2. 若管理员在企微后台为客户创建客户群发也会占用群发机会。</p>
        <p>3. 图片：支持jpg、png格式，大小不超过10MB；</p>
        <p>4. 视频：支持mp4、avi、wmv、rmvb、mov、m4v，大小不超过10MB；</p>
        <p>5. 文件：支持word、pdf、excel、txt、ppt、rar、html格式，大小不超过20MB；</p>
      </div>

      <div class="fixed_bottom fixed_horizo_center" v-show="isFixedBottoms">
        <div class="button_bottom">
          <dl @click="resetUser">取消</dl>
          <dl
            @click="ensureComfirm"
            ref="ensureConfirm"
            :style="{
              opacity: groupName.length > 0 && user_str.length > 0 && messageWord.length ? 1 : 0.5,
            }"
          >
            立即发送
          </dl>
        </div>
      </div>

      <users-list v-show="isUserList" @appendUser="appendIUser" @cancelUser="cancelUser"> </users-list>

      <tag-group v-show="isTagList" @appendTag="appendTag" @cancelTag="cancelTag"> </tag-group>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>

<script>
import { Toast } from "vant";
import { wegroupsendSave, wegroupsendSendCount } from "@/server/api.js";
import AddFile from "@/views/wegroupsend/addFile";
import usersList from "@/views/wegroupsend/usersList";
import { wefunstatistics, pageLimit } from "@/utils/public.js";
import tagGroup from "@/views/wegroupsend/tagGroup";
import emptyPage from "@/components/emptyPage";

export default {
  name: "customerGroup",
  components: { AddFile, tagGroup, usersList, emptyPage },
  data() {
    return {
      groupName: "",
      users: [],
      tags: [],
      messageWord: "",
      id: "",
      user_str: "",
      externalUserids: [],
      qWediaAttachmentsDataVos: [],
      isTagMore: false,
      isUserMore: false,
      isUserList: false,
      isTagList: false,
      userIds: [],
      tagIds: [],
      isFixedBottoms: true,
      sendCount: 0,
      isLimit: "",
    };
  },
  async created() {
    let that = this;
    await pageLimit("wegroupsend:save", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      await wefunstatistics("13", window.location.href.split("#")[0]);
    }
  },

  watch: {
    users: {
      handler(val) {
        this.user_str = "";
        for (let i of val) {
          this.user_str += JSON.parse(i).realname + "、";
        }
        let that = this;
        if (val.length === 0 && this.tags.length === 0) {
          this.sendCount = 0;
        } else {
          this.requestSendCount();
        }
        this.$nextTick(() => {
          that.isMoreUser();
        });
      },
      deep: true,
    },

    tags: {
      handler(val) {
        let that = this;
        if (val.length === 0 && this.users.length === 0) {
          this.sendCount = 0;
        } else {
          //console.log('fff')
          this.requestSendCount();
        }
        this.$nextTick(() => {
          that.isMoreTag();
        });
      },
      deep: true,
    },
  },
  methods: {
    async requestSendCount() {
      let paramTextVo = {
        isTags: this.tagIds,
        userids: this.userIds,
        noTags: [],
        endTime: "",
        startTime: "",
      };
      const resData = await wegroupsendSendCount({
        userType: 3,
        paramTextVo,
      });
      if (resData.code !== "200") return Toast.fail(resData.msg);
      this.sendCount = resData.data;
    },

    ensureComfirm() {
      let form = this.$refs.form;
      let users_field = this.$refs.users_field.$el;
      if (!this.user_str) {
        users_field.style.display = "block";
      }
      form
        .validate(["groupName", "user", "messageWord"])
        .then(async () => {
          if (this.sendCount === 0)
            return this.$notify({
              type: "warning",
              message: "您所选学员数量为0，不能发送吆",
            });

          let paramTextVo = {
            isTags: this.tagIds,
            userids: this.userIds,
            noTags: [],
            endTime: "",
            startTime: "",
          };
          let params = {
            name: this.groupName,
            externalUserids: [],
            status: 2,
            sentText: this.messageWord,
            userType: 3,
            paramTextVo,
            sendCount: this.sendCount,
            qWediaAttachmentsDataVos: this.qWediaAttachmentsDataVos,
          };
          //console.log(params);
          const res = await wegroupsendSave(params);
          if (res.code !== "200") return Toast.fail(res.msg);
          if (res.success) {
            //console.log(res);
            await this.$router.push("/index");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //更新附件数据集合
    listArr(val) {
      this.qWediaAttachmentsDataVos = val;
    },

    isFixedBottom(bool) {
      this.isFixedBottoms = bool;
    },

    resetUser() {
      this.$router.push("index");
    },

    isMoreTag() {
      let customerList = document.querySelector(".tagWraps");
      if (customerList.offsetHeight > 68) {
        customerList.classList.add("overFlow");
        this.isTagMore = true;
      }
    },

    isMoreUser() {
      let customerList = document.querySelector(".usersWrap");
      let usersField = document.querySelector(".users_field");
      // let right_arrow = document.querySelector(".right_arrow");
      if (this.user_str) {
        customerList.parentElement.style.position = "relative";
        usersField.classList.remove("emptyUsers");
        // right_arrow.style.top='-30px';
      } else {
        customerList.parentElement.style.position = "absolute";
        // right_arrow.style.top='-11px';
        usersField.classList.add("emptyUsers");
      }
      if (customerList.offsetHeight > 60) {
        customerList.classList.add("overFlow");
        this.isUserMore = true;
        // alert(this.isUserMore)
      }
    },

    //选择员工
    appendIUser(val, bool) {
      this.users = [...val];
      this.userIds = [];
      for (let i of val) {
        this.userIds.unshift({
          userId: JSON.parse(i).weUserId,
          userName: JSON.parse(i).realname,
        });
      }
      this.isUserList = bool;
    },
    //取消
    cancelUser(bool) {
      this.isUserList = bool;
    },

    cancelTag(bool) {
      this.isTagList = bool;
    },

    //选择标签
    appendTag(val, bool) {
      this.tagIds = [];
      for (let i of val) {
        this.tagIds.unshift({
          tagId: i.id,
          tagName: i.name,
        });
      }
      this.tags = [...val];
      this.isTagList = bool;
    },

    //点击展开标签
    expandClickTag(e) {
      let element = e.currentTarget;
      element.previousElementSibling.classList.remove("overFlow");
      this.isTagMore = false;
    },

    expandClickUser(e) {
      let element = e.currentTarget;
      element.previousElementSibling.classList.remove("overFlow");
      this.isUserMore = false;
    },
    //显示标签勾选
    routerTag() {
      this.isTagList = true;
    },

    //跳转到选人
    routerUser() {
      this.isUserList = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "css/index";
</style>
